import { render, staticRenderFns } from "./RPMgmActivityDetail.vue?vue&type=template&id=b0ad1cb4"
import script from "./RPMgmActivityDetail.vue?vue&type=script&lang=js"
export * from "./RPMgmActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports